import * as React from 'react';
import Tabs, { TabsProps } from '@mui/material/Tabs';
import Tab, { TabProps } from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useState } from 'react';
import { colors } from '../utils/theme';
import { sendEvent } from '../utils';
import { AnalyticsData } from '../types';

function a11yProps(index: number) {
  return {
    id: `rootine-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export interface RootineTabsProps {
  tabs: { [title: string]: JSX.Element };
  hideTabs: boolean;
  tabsProps?: TabsProps;
  tabProps?: TabProps;
  analyticsData?: AnalyticsData;
}

export const RootineTabs = ({
  tabs,
  hideTabs,
  tabsProps,
  tabProps,
  analyticsData,
}: RootineTabsProps) => {
  const tabKeys = Object.keys(tabs);
  const [value, setValue] = useState(tabs[tabKeys[0]]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newIndex: number) => {
    setSelectedIndex(newIndex);
    setValue(tabs[tabKeys[newIndex]]);
    sendEvent(analyticsData?.eventName || 'Rootine Tab Change', {
      ...analyticsData?.data,
      tabName: tabKeys[newIndex],
    });
  };

  return (
    <Box sx={{ width: '100%' }}>
      {!hideTabs && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={selectedIndex}
            onChange={handleChange}
            centered
            aria-label="rootine tabs"
            {...tabsProps}
          >
            {tabKeys.map((tabKey, i) => {
              return (
                <Tab
                  key={`key-${tabKey}`}
                  label={tabKey}
                  {...a11yProps(i)}
                  sx={{
                    fontSize: { xs: 12, md: 24 },
                    color: colors.greys.TEXT_BLACK,
                    borderBottom: `${
                      selectedIndex === i
                        ? `1px solid ${colors.greys.TEXT_BLACK}`
                        : ''
                    }`,
                  }}
                  {...tabProps}
                />
              );
            })}
          </Tabs>
        </Box>
      )}

      {tabKeys.map((tabKey: string, i: number) => {
        const show = i === selectedIndex;
        return (
          <Box key={`tabkey-${tabKey}`}>{show && <>{tabs[tabKey]}</>}</Box>
        );
      })}
    </Box>
  );
};
